<template>
  <div>
    <p class="text-purple05">
      {{ labels.changePaymentMethod }}
      <br />
      <a class="bold text-primary">{{ labels.contactUs }}</a>
    </p>
    <img src="../../assets/payment/boleto.svg" class="boleto" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({ resources: 'resources' }),

    labels: function() {
      return this.resources.page.home.accountGeneric
    },
  },
}
</script>

<style lang="scss">
img.boleto {
  max-width: 200px;

  @media (max-width: 425px) {
    display: inherit;
    margin: 0 auto;
  }
}
</style>
